export default __webpack_public_path__ + "static/media/glitch04.8576cdfe.png";